


















































import Onboarding from '@/util/Onboarding'
import { Vue, Component } from 'vue-property-decorator'

interface InputValue {
    value: string
    error: string | null
}

@Component({ name: 'user-details' })
export default class UserDetails extends Vue {
    username: InputValue = { value: '', error: null }
    email: InputValue = { value: '', error: null }

    loading: boolean = false

    mounted(): void {
        (this.$refs.username as HTMLElement).focus()
    }

    async submit(): Promise<void> {
        this.loading = true

        let cancel = false
        const usernameCheck = await Onboarding.checkUsername(this.username.value)
        if (!usernameCheck.valid) {
            cancel = true
            this.username.error = usernameCheck.error
        }

        const emailCheck = await Onboarding.checkEmail(this.email.value)
        if (!emailCheck.valid) {
            cancel = true
            this.email.error = emailCheck.error
        }

        if (!cancel) {
            this.$emit('user-details-complete', {
                username: this.username.value,
                email: this.email.value
            })
        }
        this.loading = false
    }
}
